/** Design tokens for the catalog-first "Create source / destination" modals. */
export const COLORS = {
    white: "#ffffff",
    slate50: "#f8fafc",
    slate100: "#f1f5f9",
    slate200: "#e2e8f0",
    slate300: "#cbd5e1",
    slate400: "#94a3b8",
    slate500: "#64748b",
    slate600: "#475569",
    slate700: "#334155",
    slate800: "#1e293b",
    slate900: "#0f172a",
    /** SignalSight primary (matches `theme.palette.primary.main`). */
    primary: "#ed6c02",
    primaryDark: "#c55a00",
    primarySoft: "rgba(237, 108, 2, 0.06)",
    primarySoftBorder: "rgba(237, 108, 2, 0.35)",
    primaryRing: "rgba(237, 108, 2, 0.18)",
    error: "#ba1a1a",
};

export const RADIUS = {
    sm: "4px",
    md: "8px",
    lg: "12px",
    paper: "20px",
    full: "9999px",
};

export const SHADOW = {
    xs: "0 1px 1px rgba(15, 23, 42, 0.04)",
    sm: "0 1px 2px rgba(15, 23, 42, 0.06)",
    md: "0 4px 12px rgba(15, 23, 42, 0.08)",
    paper: "0 25px 50px -12px rgba(15, 23, 42, 0.25)",
    focusRing: `0 0 0 3px ${COLORS.primaryRing}`,
    selectedRing: `0 0 0 2px rgba(237, 108, 2, 0.12)`,
};

export const TYPOGRAPHY = {
    title: {
        fontSize: "20px",
        lineHeight: "28px",
        letterSpacing: "-0.015em",
        fontWeight: 600,
    },
    sectionTitle: {
        fontSize: "14px",
        lineHeight: "20px",
        letterSpacing: "-0.01em",
        fontWeight: 600,
    },
    bodyMd: {
        fontSize: "14px",
        lineHeight: "20px",
        fontWeight: 400,
    },
    bodySm: {
        fontSize: "12px",
        lineHeight: "18px",
        fontWeight: 400,
    },
    labelMd: {
        fontSize: "13px",
        lineHeight: "16px",
        fontWeight: 500,
    },
    labelSm: {
        fontSize: "12px",
        lineHeight: "16px",
        fontWeight: 500,
    },
    labelXs: {
        fontSize: "11px",
        lineHeight: "14px",
        fontWeight: 500,
    },
};

export const PAPER_MAX_WIDTH = 960;

export const CreationModalStep = Object.freeze({
    CATALOG: "CATALOG",
    CONFIGURE: "CONFIGURE",
});

/** `TypeCatalog` card height is fixed so rows stay aligned regardless of copy length. */
export const CATALOG_CARD_MIN_HEIGHT = 168;
